// 套藥取藥 component

<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        Loader(v-if="getMedGroup === false && stage === 'medGroupList'")
        div.med-group-wrapper(v-if="getMedGroup && stage === 'medGroupList'")
          ul.nav.nav-pills.nav-fill.nav-autoix
            li.nav-item(v-for="g, index in group" @click="currentGroupIndex = index")
              div.nav-link(:class="{ 'active': currentGroupIndex === index }" ) {{g.name}}
          div.med-select
            div.med-button(
              :class="{ 'selected-med-button': med.selected, 'unselectable': med.amountInSystem === 0 }"
              v-for="med, index in group[currentGroupIndex].childMedSet"
              @click="selectMed(index)") 
              div#med_desc
                h6 {{ med.code }} - {{ med.CGMH_number }}
                h6 {{ med.generic_name }}
              div#remain_amount 
                span 系統存量
                span {{ med.amountInSystem }}
        MultiFlow(
          v-if="stage === 'startFlow'"
          :multiProgress="multiProgress"
          :confirmProgress="confirmProgress"
          :actionProgress="actionProgress"
          v-on:setAllConfirmData="getAllConfirmData"
        )
    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel" :clickable="currentApp.cancel")
      //- action-button(title="全部藥物" slot="button-5" @click.native="$router.push({ name: 'fetchDrug' })")
      action-button(title="醫囑取藥" slot="button-3" @click.native="$router.push({ name: 'schedule', params: { stage: 'ComboMedListAndPatient' } })" v-if="$store.state.user.user.med_app_privilege.fetch_by_schedule")
      //- action-button(title="套藥取藥" slot="button-7" @click.native="$router.push({ name: 'fetchDrugCombo' })" v-if="$store.state.user.user.med_app_privilege.fetch_by_schedule")
      action-button(title="類別取藥" slot="button-4" @click.native="$router.push({ name: 'fetchDrugGroup' })" v-if="$store.state.user.user.med_app_privilege.fetch_by_schedule")
      action-button(title="開始取藥" slot="button-9" @click.native="startFlow")

              
</template>

<script>
import _ from 'lodash';
import progressBar from './flowComp/ProgressBar';
import Loader from './common/Loader';
import MultiFlow from './FetchDrugGroupFlow/MultiFlow';
import BottomButtons from './common/BottomButtons';


export default {
  name: 'FetchDrugCombo',
  components: {
    progressBar,
    Loader,
    MultiFlow,
    BottomButtons,
  },
  data() {
    return {
      group: [],
      getMedGroup: false,
      currentGroupIndex: 0,
      stage: 'medGroupList',
      scheduleId: null,
    };
  },
  created() {
    this.$store.commit('SET_APP', '套組取藥');
    this.$store.commit('SET_PROGRESS', this.progress);
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.getGroup();
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
    progress() {
      const p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push({ en: 'medIdInput', zh: '輸入病歷號' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    multiProgress() {
      const p = [];
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push('medIdInput');
      }
      p.push('confirm');
      p.push('finish');
      return p;
    },
    confirmProgress() {
      return [
        'action',
      ];
    },
    actionProgress() {
      const prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
  },
  methods: {
    getGroup() {
      this.instance.get('/api/combo-medication-set/')
      .then((res) => {
        const comboMedSets = {};
        res.data.forEach((relation) => {
          if (comboMedSets[relation.parent_medication.id] === undefined) {
            comboMedSets[relation.parent_medication.id] = {};
            comboMedSets[relation.parent_medication.id].name = relation.parent_medication.generic_name;
            comboMedSets[relation.parent_medication.id].childMedSet = [];
            comboMedSets[relation.parent_medication.id].selected = false;
          }
          const childMed = relation.child_medication;
          childMed.selected = false;
          childMed.drugInDevice = _.filter(this.$store.getters.drugInDeviceList, (drugStorage) => {
            return drugStorage.medication.id === childMed.id && drugStorage.stock > 0;
          });
          childMed.amountInSystem = 0;
          childMed.drugInDevice.forEach((d) => {
            childMed.amountInSystem += d.stock;
          });
          comboMedSets[relation.parent_medication.id].childMedSet.push(childMed);
        });
        console.log(comboMedSets);
        this.group = Object.values(comboMedSets);
        this.getMedGroup = true;
      });
    },
    selectMed(index) {
      const med = this.group[this.currentGroupIndex].childMedSet[index];
      med.selected = !med.selected;
      console.log(med);
      const payload = {
        med,
        drugStorage: med.drugInDevice,
        amount: 1,
        select: med.selected,
      };
      this.$store.dispatch('setDrugListForFetch', payload);
    },
    cancel() {
      this.$router.push({ name: 'Main' });
    },
    startFlow() {
      this.stage = 'startFlow';
      // this.$store.dispatch('startSchedulMed');
    },
    getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      this.stage = 'ScheduleList';
      this.$router.push({ name: 'schedule' });
    },
  },
};
</script>

<style lang="sass">
.med-group-wrapper
  height: 100%
  display: flex
  flex-direction: column
  

.group-select
  display: table
  flex-direction: column
  border-collapse: collapse
  .group-button
    display: table-cell
    text-align: center
    background-color: steelblue
    color: white
    padding: 10px
    border: 1px solid white


.nav-autoix
  width: 100%
  // box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.2);
  // border-bottom: 1px solid rgba(0,0,0,0.2)
  .active
    background-color: steelblue !important
  .nav-link
    background-color: aliceblue
    border-radius: 0  


.med-select
  height: calc(100% - 40px)
  overflow-y: scroll
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 6px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;


.med-button
  margin: 5px 5px
  box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  // border: 1px solid transparent
  background-color: #f4f4f4
  border-color: #dbdbdb
  display: flex;
  justify-content: space-between;
  transition: all ease 0.3s
  padding: 5px 10px
  #med_desc
    h6
      margin: 0.5rem
      &:nth-child(2)
        font-size: 12px
  #remain_amount
    border-left: 1px solid rgba(0,0,0,0.2)
    padding: 5px 15px
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    span
      font-size: 20px
      &:first-child
        font-size: 12px
      
.unselectable
  pointer-events: none;
  box-shadow: none;
  border-style: unset
  color: rgba(0,0,0,0.3)
  .amount-button
    background-color: rgba(0,0,0,0.3) !important
  #remain_amount
    color: red

.selected-med-button
  background: cadetblue
  color: white
  #remain_amount
    border-color: white
</style>



// WEBPACK FOOTER //
// FetchDrugCombo.vue?00cc2eba